import { MegaMenuPanelData } from "@/common/contracts/mega-menu.contracts";
import { MegaMenuHeaderItem } from "@/components/mega-menu/MegaMenuHeaderItem";
import { NavigationMenuList } from "@radix-ui/react-navigation-menu";

/*
 * "About us" is in the footer already; in the desktop bar it pushed the row onto a second
 * line. The Strapi menu still carries it for the mobile menu, so it's dropped here only.
 */
const DESKTOP_HIDDEN_SUBMENU_SLUGS = new Set(["about"]);

export const MegaMenuHeaderItemList = ({ items }: MegaMenuPanelData) => {
  return (
    <NavigationMenuList
      data-mega-menu-items
      className="flex flex-wrap items-center space-x-6 space-y-2 pb-4 [&>:first-child]:mt-2"
    >
      {items
        ?.filter(
          item => !DESKTOP_HIDDEN_SUBMENU_SLUGS.has(item.submenuSlug ?? "")
        )
        .map(item => <MegaMenuHeaderItem key={item.id} {...item} />)}
    </NavigationMenuList>
  );
};
